import {AbstractStripePaymentRequestPayment} from './abstract/class-abstract-stripe-paymentrequest-payment';

class StripeGooglepayPayment extends AbstractStripePaymentRequestPayment {
	public gatewayId(): string {
		return 'peachpay_stripe_googlepay';
	}

	protected paymentRequestType(): 'googlePay' | 'applePay' {
		return 'googlePay';
	}
}

export {StripeGooglepayPayment};
